import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import posthog from 'posthog-js';
// Initialize PostHog with hardcoded public keys
posthog.init('phc_4lFodIurmLUMyZT6bAzB9Cxg0IMEJMU9d6GLb50unZ2', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only'
});
// Inject Google Analytics (gtag.js)
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-42YJYMFYL4';
document.head.appendChild(gtagScript);
const gtagInline = document.createElement('script');
gtagInline.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-42YJYMFYL4');
`;
document.head.appendChild(gtagInline);
render(<App data-id="element-396" data-mp="2u0ptwq0iwlql" />, document.getElementById('root'));